import http from '../http-common';
import authHeader from './auth-header';

const API_URL = '/api/auth/vipps/';

class VippsService {
  getUserInfo(code) {
    return http
      .get(API_URL + `getUserInfo/${code}`, { headers: authHeader() })
      .then(response => {
        if (response.data.accessToken) {
          console.log('VippsService.getUserInfo: response.data:', response.data);
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  updateAuthorizationInfo() {
    return http
      .get(API_URL + "updateAuthorizationInfo", { headers: authHeader() })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  getPaymentStatus(payment_id) {
    return http
      .get(`/api/vipps/payment/${payment_id}/status`, { headers: authHeader() })
      .then(response => {
        return response.data;
      });
  }

}

export default new VippsService();